import { createContext, useContext } from "react";



type tokenContext = {
    numOfTokens:number
    isLoading?:boolean
}


export const TokenContext = createContext<tokenContext| undefined>(undefined)

const useTokenContext = () => {
  const context = useContext(TokenContext);
  if (context === undefined) {
    throw new Error("useTokenContext must be used within a TokenView");
  }
  return context;
}
export {useTokenContext}